import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, first, tap, throwError } from 'rxjs';

import { AuthService } from '../auth.service';

type ClaimState = 'loading' | 'success' | 'error';

@Component({
  selector: 'app-claim-applications',
  templateUrl: './claim-applications.component.html',
  styleUrls: ['./claim-applications.component.scss'],
})
export class ClaimApplicationsComponent implements OnInit {
  public state: ClaimState = 'loading';
  public errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (!token) {
      this.state = 'error';
      this.errorMessage = 'Invalid claim link. No token provided.';
      return;
    }

    this.confirmClaim(token);
  }

  private confirmClaim(token: string): void {
    this.authService.confirmClaim(token)
      .pipe(
        catchError(error => {
          this.state = 'error';
          if (error.status === 400) {
            this.errorMessage = 'Invalid or expired claim link.';
          } else if (error.status === 404) {
            this.errorMessage = 'Claim token not found.';
          } else {
            this.errorMessage = error.error?.message || 'Failed to claim applications. Please try again.';
          }
          return throwError(() => error);
        }),
        first(),
        tap(() => {
          this.state = 'success';
        })
      )
      .subscribe();
  }

  public goToApplications(): void {
    this.router.navigate(['/candidate/applications']);
  }

  public goToLogin(): void {
    this.router.navigate(['/candidate-login']);
  }
}
